import "./index.css";

import { MsalProvider } from "@azure/msal-react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App.tsx";
import {
  ensureMsalInitialized,
  msalInstance,
  setPendingAuthError,
} from "./config/msalInstance";

const isBypassSso = import.meta.env.VITE_BYPASS_SSO === "true";

async function bootstrap() {
  if (!isBypassSso) {
    try {
      await ensureMsalInitialized();
      // Complete any in-flight redirect sign-in and set the active account.
      const result = await msalInstance.handleRedirectPromise();
      const account = result?.account ?? msalInstance.getAllAccounts()[0] ?? null;
      if (account) {
        msalInstance.setActiveAccount(account);
      }
    } catch (error) {
      setPendingAuthError(error);
    }
  }

  const app = <App />;

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      {isBypassSso ? app : <MsalProvider instance={msalInstance}>{app}</MsalProvider>}
    </StrictMode>
  );
}

void bootstrap();
